import { Injectable } from '@angular/core';

export interface SalesforceLaunchState {
  tenantIdentifier: string;
  recordId: string;
  objectApiName: string;
  phoneNumber?: string | null;
  email?: string | null;
  externalCustomerId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class SalesforceLaunchStateService {
  private readonly storageKey = 'aidar-salesforce-launch';

  public setPendingLaunch(launch: SalesforceLaunchState): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(launch));
  }

  public getPendingLaunch(): SalesforceLaunchState | null {
    const rawValue = sessionStorage.getItem(this.storageKey);
    if (!rawValue) {
      return null;
    }

    try {
      const launch = JSON.parse(rawValue) as SalesforceLaunchState;
      return this.isValidLaunch(launch) ? launch : null;
    } catch {
      return null;
    }
  }

  public clearPendingLaunch(): void {
    sessionStorage.removeItem(this.storageKey);
  }

  private isValidLaunch(
    launch: SalesforceLaunchState | null | undefined,
  ): boolean {
    return (
      !!launch?.tenantIdentifier && !!launch.recordId && !!launch.objectApiName
    );
  }
}
